// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
}

button {
  background: none;
  outline: none;
  margin: 0;
  border: none;
  cursor: pointer;
  color: inherit;
}

a {
  color: black;
  text-decoration: underline;
}

input,
select {
  line-height: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/library/style/reset.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":["body {\n  margin: 0;\n}\n\nbutton {\n  background: none;\n  outline: none;\n  margin: 0;\n  border: none;\n  cursor: pointer;\n  color: inherit;\n}\n\na {\n  color: black;\n  text-decoration: underline;\n}\n\ninput,\nselect {\n  line-height: 1.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
